module.exports = __webpack_public_path__ + "img/title.735f2f0.png";